import React from 'react'
import { disableReactDevTools } from '@fvilers/disable-react-devtools'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import i18n, { i18nOptions } from './i18n'
import { subdomain } from './constants'

if (process.env.NODE_ENV === 'production') {
  disableReactDevTools()
}

console.log(`Welcome to ${subdomain}`)

const main = async () => {
  try {
    await i18n.init(i18nOptions())
    ReactDOM.render(<App />, document.getElementById('root'))
  } catch (err) {
    console.error('something went wrong loading', err)
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (process.NODE_ENV !== 'production') reportWebVitals(console.log)

main()
